import {handleAction} from 'uix/actions'
import {setLanguage, updateBaseLanguage} from './actions'
import {switchLanguageFormat} from 'uix/utils/format'

export const config = [
  handleAction(setLanguage, (config, action) => {
    let {dname, i18ndata, cacheKeys} = action.payload
    if (i18ndata && cacheKeys) {
      let ddata = config.ddata[dname]
      ddata = {
        ...ddata,
        i18n: {...ddata.i18n, ...i18ndata},
        cacheKeys: {...ddata.cacheKeys, ...cacheKeys},
      }

      return {
        ...config,
        ddata: {...config.ddata, [dname]: ddata},
      }
    }
    return config
  }),
  handleAction(updateBaseLanguage, (config, {payload}) => {
    let bundle = payload.bundle || {}
    if (!bundle || Object.keys(bundle).length === 0) {
      return config
    }
    let current = config.instance.i18n || {}
    let next = {...current}
    for (let [language, data] of Object.entries(bundle)) {
      next[language] = {...next[language], ...data}
    }
    return {...config, instance: {...config.instance, i18n: next}}
  }),
]

export const meta = [
  handleAction(
    setLanguage,
    (meta, {payload}) => {
      switchLanguageFormat(payload.language)
      let merged = payload.merged || {}
      return {
        ...meta,
        language: payload.language,
        i18n: merged[payload.language] || {},
      }
    },
    {language: null, i18n: {}}
  ),
]
